import { render, staticRenderFns } from "./table-guia.vue?vue&type=template&id=61e8d5d7&scoped=true&"
import script from "./table-guia.vue?vue&type=script&lang=js&"
export * from "./table-guia.vue?vue&type=script&lang=js&"
import style0 from "./table-guia.vue?vue&type=style&index=0&id=61e8d5d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e8d5d7",
  null
  
)

export default component.exports